/* eslint-disable @typescript-eslint/no-explicit-any */
import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import dayjs from "./dayjs.utils"
import { Locales, LocaleTranslations } from "@/constants/locales.constants.ts";
import { SettingsStore } from "@/store/settings/settings.store";
import i18nCustomResources from "@/assets/locales/fr/custom-translations";

const formatTranslation = (value: any, format?: string, locale?: string) => {
  if (value instanceof Date && locale && format) {
    return dayjs(value).locale(locale).format(format)
  }

  if (typeof value === "string" && format === "uppercase") {
    return value.toUpperCase()
  }

  if (typeof value === "string" && format === "lowercase") {
    return value.toLowerCase()
  }

  return value
}

export const loadCustomTranslations = (brandName: string) => {
  const formattedBrandName = brandName.toLowerCase().replace(/\s+/g, '');
  const customTranslations = i18nCustomResources[formattedBrandName];

  if (customTranslations) {
    i18n.addResourceBundle('EN', 'translation', customTranslations.EN, true, true);
    i18n.addResourceBundle('FR', 'translation', customTranslations.FR, true, true);
  }
};

declare module "i18next" {
  interface CustomTypeOptions {
    returnNull: false
  }
}

export const getBrowserLocale = () => {
  const language = window.navigator.language || window.navigator.languages[0];

  const languageMapping: Record<string, Locales> = {
    fr: Locales.FR,
    en: Locales.EN,
  };

  const mainLanguage = language.split('-')[0];
  return languageMapping[mainLanguage] || Locales.EN;
};

i18n
  .use(initReactI18next)
  .init({
    returnNull: false,
    resources: LocaleTranslations,
    fallbackLng: Locales.EN,
    lng: SettingsStore.getState().language,
    returnObjects: true,
    interpolation: {
      escapeValue: false,
      format: formatTranslation,
    },
  })

export default i18n;
